import React from "react";
import classNames from "classnames";

const ProfileSection = ({ className, ...props }) => (
  <section {...props} className={classNames("profile-section", className)} />
);

export default ProfileSection;
